export const USER_TYPE_ANONYMOUS = 'anonymous';
